import { useMemo } from "react";
import { useLocation, useHistory } from "react-router-dom";

import IntegrationMarketModal from "../../PagesComponents/IntegrationsMarket/Modal/IntegrationMarketModal";
import IntegrationConfigListHeader from "./Components/IntegrationConfigListHeader";
import IntegrationConfigListBody from "./Components/IntegrationConfigListBody";

import PlusIcon from "../../Icon-SVG/PlusIcon";

import "./styles.scss";

const IntegrationConfigList = ({ show, setShow, activeInt, setActiveInt, data }) => {
  const history = useHistory();
  const location = useLocation();

  const query = useMemo(() => {
    return new URLSearchParams(location.search);
  }, [location.search]);

  const closeAll = () => {
    setShow(false);
    setActiveInt("");
  };

  const closePopupHandler = () => {
    if (query.get("bck")) {
      closeAll();
      history.push("/integration-market");
    } else {
      closeAll();
    }
  };

  const rowOnClickHandler = (int, i) => {
    history.push(`integration-market?conf=${int}&t=${i}`);
    closeAll();
  };

  const handleAdd = () => {
    history.push(`integration-market?conf=${activeInt}&t=add`);
    closeAll();
  };

  if (!show) return null;

  return (
    <IntegrationMarketModal title={data?.cardName} onClose={closePopupHandler}>
      <div className="integration-configTable-wrapper">
        <IntegrationConfigListHeader
          columns={data?.listPopup?.titles || []}
          trash={data?.listPopup?.trashButton}
        />
        <IntegrationConfigListBody
          onClickHandler={rowOnClickHandler}
          intname={data?.intname}
          messageonly={data?.messageonly}
          columns={data?.listPopup?.titles || []}
          trash={data?.listPopup?.trashButton}
          mountPoint={data?.listPopup?.mountPoint || null}
        />
      </div>
      <button onClick={handleAdd} className="integration-market-modal__add-button primary-button">
        <PlusIcon color="var(--dashboard-value-color)" width={16} height={16} />
        Add Config
      </button>
    </IntegrationMarketModal>
  );
};

export default IntegrationConfigList;
